module.exports = __webpack_public_path__ + "static/media/paytm.eba8454b.png";